import { frontendURL } from 'dashboard/helper/URLHelper';
import { kanbanRoutePermissions } from 'dashboard/helper/kanbanPermissions';
import {
  KANBAN_ACCESS_PERMISSIONS,
  KANBAN_ANALYTICS_BLOCK_PERMISSIONS,
  KANBAN_OWN_DEALS_ONLY_PERMISSIONS,
  KANBAN_MANAGE_PERMISSIONS,
} from 'dashboard/constants/permissions';

const KanbanBoardPage = () =>
  import('dashboard/components-next/kanban/KanbanBoardPage.vue');
const KanbanAnalyticsPage = () =>
  import('dashboard/components-next/kanban/analytics/AnalyticsPage.vue');
const ScheduledActionsPage = () =>
  import('dashboard/components-next/kanban/scheduled-actions/ScheduledActionsPage.vue');

// Atendente sem papel entra ('agent'); papel personalizado só com um degrau
// de Kanban — o 'custom_role' genérico que ficava aqui deixava QUALQUER papel
// entrar (helper/kanbanPermissions.js).
const viewerMeta = {
  permissions: ['agent', ...kanbanRoutePermissions(KANBAN_ACCESS_PERMISSIONS)],
};

const managerMeta = {
  permissions: kanbanRoutePermissions(KANBAN_MANAGE_PERMISSIONS),
};

// O Designer de Fluxo (`/kanban/flow-designer` e `.../pipelines/:id`) foi
// APOSENTADO: a configuração que vivia lá — fase, SLA, automações, identidade
// do funil e passagens — doca no próprio quadro (KanbanConfigDrawer). O canvas
// desenhava as fases como caixinhas, a mesma sequência que as COLUNAS já
// desenham com os cards dentro; a paleta de "Atribuições" era uma segunda porta
// pras automações `stage_entered`, não um recurso próprio.
//
// Sem redirect de propósito: as rotas nunca chegaram a produção, e um redirect
// mantém vivo um endereço que só existe pra ser descoberto por engano.
const kanbanRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/kanban'),
      name: 'kanban_board',
      meta: viewerMeta,
      component: KanbanBoardPage,
    },
    {
      path: frontendURL('accounts/:accountId/kanban/analytics'),
      name: 'kanban_analytics',
      // Papel "só o quadro" ou "só os meus cards" (o Analytics conta o funil
      // inteiro): o guard recusa a rota (routeIsAccessibleFor).
      meta: {
        ...viewerMeta,
        blockedBy: [
          KANBAN_ANALYTICS_BLOCK_PERMISSIONS,
          KANBAN_OWN_DEALS_ONLY_PERMISSIONS,
        ],
      },
      component: KanbanAnalyticsPage,
    },
    {
      // kanban_manage, mesma régua do backend (ScheduledActionPolicy):
      // cancelar agendamento move card e manda mensagem sozinho.
      path: frontendURL('accounts/:accountId/kanban/scheduled-actions'),
      name: 'kanban_scheduled_actions',
      meta: managerMeta,
      component: ScheduledActionsPage,
    },
  ],
};

export default kanbanRoutes;
